import { createSignal } from 'solid-js'

const supports = {
  en: 'en',
  'en-US': 'en',
  zh: 'zh-Hans',
  'zh-CN': 'zh-Hans',
  'zh-HK': 'zh-Hant',
  'zh-SG': 'zh-Hant',
  'zh-TW': 'zh-Hant',
}

const SUPPORTED_LANGS = ['en', 'zh-Hant', 'zh-Hans']

const initialLang = localStorage.lang ?? supports[window.navigator.language ?? window.navigator.languages.at(0)] ?? 'en'

const [currentLang, setCurrentLang] = createSignal(initialLang)

// lang 必須維持字串型別的 live binding：CRM 有大量把 lang 當物件 key／=== 比較／URL 內插，不可改成函式
export let lang = initialLang

export { currentLang }

export function setLang(code) {
  if (!SUPPORTED_LANGS.includes(code)) return false
  localStorage.lang = code
  lang = code
  setCurrentLang(code)
  return true
}

function format(text, args = {}) {
  for (const k of Object.keys(args)) {
    text = text.replaceAll(`{${k}}`, args[k])
  }
  return text
}

export function createI18n(locals) {
  function t(scope, text, args = {}) {
    const state = locals[currentLang()]
    if (state && state[scope] && state[scope][text]) {
      return format(state[scope][text], args)
    }
    return format(text, args)
  }

  function nt(scope, text, textPlural, n, args = {}) {
    return n == 1 ? t(scope, text, args) : t(scope, textPlural, args)
  }

  return { t, nt }
}
